module.exports = __webpack_public_path__ + "static/media/F.2341477a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/F.jpg
// module id = 74
// module chunks = 0